import React from 'react';

import LinkButton from '@sats-group/ui-lib/react/link-button';
import Text from '@sats-group/ui-lib/react/text';

import type { NamedFC } from '../../types/named-fc.types';

import type { VatAgeCheck as Props } from './vat-age-check.props';

const VatAgeCheck: NamedFC<Props> = ({
  buttonOver30Text,
  buttonUnder30Text,
  description,
  descriptionTitle,
  subTitle,
  title,
}) => {
  return (
    <div className="vat-age-check">
      <div className="vat-age-check__body">
        <Text className="vat-age-check__subtitle" size="large">
          {subTitle}
        </Text>
        <Text
          elementName="h1"
          size="headline1"
          className="vat-age-check__title"
          theme="emphasis"
        >
          {title}
        </Text>
        <div className="vat-age-check__buttons">
          <LinkButton
            variant="primary-white"
            {...buttonUnder30Text}
            wide
            data-test-age-group="underThirty"
          />
          <LinkButton
            variant="primary-white"
            {...buttonOver30Text}
            wide
            data-test-age-group="overThirty"
          />
        </div>
        <div className="vat-age-check__descriptions">
          <Text theme="emphasis" size="small">
            {descriptionTitle}
          </Text>
          <Text size="small">{description}</Text>
        </div>
      </div>
      <div className="vat-age-check__background"></div>
    </div>
  );
};

VatAgeCheck.displayName = 'VatAgeCheck';

export default VatAgeCheck;
